var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingio-spinner-dual-ring-44x2g2isxmu"},[_c('div',{staticClass:"ldio-7hsu63xud14"},[_c('div'),_c('div',[_c('div')])])])
}]

export { render, staticRenderFns }